import { css } from "styled-components";
export const visuallyHidden = () => css `
  border: 0 !important;
  clip: rect(0 0 0 0) !important;
  clip-path: polygon(0px 0px, 0px 0px, 0px 0px, 0px 0px) !important;
  height: 1px !important;
  margin: -1px !important;
  overflow: hidden !important;
  padding: 0 !important;
  position: absolute !important;
  width: 1px !important;
  user-select: none !important;
`;
